import { ConfigurationOverview } from '~/app/compositions/content/configuration-overview';
import { Packages } from '~/app/compositions/sidebar/package';

import { PartialCarConfiguration } from '~/app/market-config/models/car-confi-market-configuration';
import { PartialUiConfiguration } from '~/app/market-config/models/car-confi-ui-configuration';
import { ImageViewsEnum } from '~/app/pages/configurator/models/image-views';

export const local: PartialCarConfiguration = {
	hasJetStream: true,
	financeDomain: 'AUDI.NO',
	combinations: ['trimLine', 'packages', 'paint', 'rims', 'headlights', 'interior', 'steeringWheels'],
	showCaESummaryText: true,
	engineCardKeyfacts: ['acceleration', 'maxPowerHp', 'electricRanges', 'chargingTime'],
	uiPreferences: {
		prices: {
			totalPriceFrom: 'total',
			hiddenPriceParts: [
				'financeableTotal',
				'total',
				'taxTotal',
				'taxTotalWeight',
				'totalRate',
				'taxTotalNOx',
				'taxTotalCO2',
				'importCharge',
				'destinationCharge',
			],
			vatConfig: {
				feature: 'exclusive',
				trimlineAndEngine: 'inclusive',
				totalPrice: 'inclusive',
				priceParts: {
					evVatTotal: 'hidden', // MVA
					financeableTotal: 'inclusive',
					nonFinanceableTotal: 'inclusive',
					model: 'inclusive',
					options: 'exclusive',
					total: 'inclusive',
					totalRate: 'hidden',
				},
			},
		},
	},
	showFinancingDisclaimerInDialogs: true,
	useStaticPriceDateRemark: true,
	nextBestActions: [
		{
			description: 'Bestill prøvekjøring',
			icon: '',
			labelText: 'Bestill prøvekjøring',
			target: '_blank',
			trackingName: 'testdrive',
			url: 'https://www.audi.no/no/web/no/nybil/provekjore.html',
		},
		{
			description: 'Kontakt meg ',
			icon: 'send',
			labelText: 'Kontakt meg ',
			target: '_blank',
			trackingName: 'contact',
			url: 'https://www.audi.no/no/web/no/nybil/fa-informasjon.html',
		},
	],
	summaryFooterCta: {
		description: 'Lagre til senere',
		icon: 'code',
		labelText: 'Lagre til senere',
		target: '_blank',

		trackingName: 'show audicode',
		url: '',
	},
};

export const local_ui: PartialUiConfiguration = {
	configOverviewComponent: <ConfigurationOverview />,
	options: {
		packages: () => {
			return {
				id: 'packages',
				label: 'ngc.equipment.packages',
				imageView: ImageViewsEnum.LIGHTS_FRONT_HEADLIGHTS,
				visible: true,
				component: <Packages />,
				camera: 'MRV1',
			};
		},
	},
};
